// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  serviceworker: false,
  game:{
    //url: 'http://localhost:4100/',
    //url: 'http://192.168.0.29:4100/',
    //url: 'http://192.168.2.81:4100/',
    url: 'https://beurs-game-api.dgt.cloud/',
    token: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJpc2UtZ2FtZS1hcGkiLCJpYXQiOjE1MTYyMzkwMjJ9.Tm0mXe5JEeik_QIjvN7735-7c9TMyoekP9Rmcqva8zI',
},

};



// WEBPACK FOOTER //
// /app/src/environments/environment.ts